<template>
    <v-dialog v-model="dialog" persistent width="600px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn :color="$variables.v.theme.primary"
                   depressed
                   v-bind="attrs"
                   v-on="on"
                   class="dialog-create-post-guidelines-button">
                <span v-html="$th('guidelines.guidelines')"></span>
            </v-btn>
        </template>
        <v-card flat>
            <dragger class="mr-4"></dragger>
            <v-card-title>
                <span class="headline" v-html="$th('guidelines.post.title')"></span>
            </v-card-title>
            <v-card-text>
                <span v-html="$th('guidelines.post.lines.0')"></span><br>
                <span v-html="$th('guidelines.post.lines.1')"></span><br>
                <br>
                <span v-html="$th('guidelines.post.lines.2')"></span><br>
                <span v-html="$th('guidelines.post.lines.3')"></span><br>
                <br>
                <span v-html="$th('guidelines.post.lines.4')"></span><br>
                <span v-html="$th('guidelines.post.lines.5')"></span><br>
                <br>
                <span v-html="$th('guidelines.post.lines.6')"></span><br>
                <span v-html="$th('guidelines.post.lines.7')"></span><br>
                <br>
                <b v-html="$th('guidelines.post.lines.8')"></b><br>
                <span class="font-italic">
                        <v-icon>mdi-arrow-right-bold</v-icon><span v-html="$th('guidelines.post.lines.9')"></span><br>
                        <v-icon>mdi-arrow-right-bold</v-icon><span v-html="$th('guidelines.post.lines.10')"></span><br>
                        <v-icon>mdi-arrow-right-bold</v-icon><span v-html="$th('guidelines.post.lines.11')"></span><br>
                    </span>
                <br>
                <span v-html="$th('guidelines.post.lines.12')"></span><br>
                <span v-html="$th('guidelines.post.lines.13')"></span><br>
                <span v-html="$th('guidelines.post.lines.14')"></span><br>
                <span v-html="$th('guidelines.post.lines.15')"></span><br>
                <span v-html="$th('guidelines.post.lines.16')"></span><br>
                <br>
                <span v-html="$th('guidelines.post.lines.17')"></span><br>
                <span v-html="$th('guidelines.post.lines.18')"></span><br>
                <br>
                <span v-html="$th('guidelines.post.lines.19')"></span><br>
                <span v-html="$th('guidelines.post.lines.20')"></span><br>
                <span v-html="$th('guidelines.post.lines.21')"></span><br>
                <span v-html="$th('guidelines.post.lines.22')"></span><br>
                <br>
                <span v-html="$th('guidelines.post.lines.23')"></span><br>
                <br>
                <span v-html="$th('guidelines.post.lines.24')"></span><br>
                <b v-html="$th('guidelines.post.lines.25')"></b><br>
                <br>
                <b v-html="$th('guidelines.post.lines.26')"></b><br>
                <br>
                <b v-html="$th('guidelines.post.lines.27')"></b><br>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1"
                       text
                       @click="dialog = false"><span v-html="$th('guidelines.accept')"></span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() {
            return {
                dialog: false,
            }
        },
    }
</script>